// @flow
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import bem from '@justpark/helpers/src/bem/bem';
import FilterIcon from '@justpark/ui/src/components/Icons/FilterIcon';
import { getQueryParam } from '../../../helpers/utils';
import { gtagTrack } from '../../../helpers/Tracking/Analytics';

import '../../../../static/scss/components/searchFilters/searchResultsFilterButton.scss';

const className = 'c-search-results-filter-button';

type Props = {
  searchQuery: string
};

const SearchResultsFilterButton = ({ searchQuery }: Props) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsObject = Object.fromEntries([...searchParams]);
  const showFilterPanel = searchParams.get('showFilterPanel');
  const listingId = searchParams.get('listingId');

  const togglePanel = () => {
    gtagTrack('srp_filter_menu');

    if (!showFilterPanel && listingId) {
      return setSearchParams({
        ...searchParamsObject,
        showFilterPanel: true,
        listingId: undefined,
        listingType: undefined
      });
    }

    if (showFilterPanel) {
      delete searchParamsObject.showFilterPanel;
      return setSearchParams(searchParamsObject);
    }

    searchParamsObject.showFilterPanel = true;
    return setSearchParams(searchParamsObject);
  };

  const filterString = getQueryParam(searchQuery, 'filters');
  const { length: filterLength } = filterString ? filterString.split(',') : [];
  const lengthFormatted = filterLength > 9 ? `9+` : filterLength;

  return (
    <button className={className} type="button" onClick={togglePanel}>
      <FilterIcon type="secondary" />
      {filterLength > 0 && (
        <div className={bem(className, 'counter')}>
          <span>{lengthFormatted}</span>
        </div>
      )}

      <p className={bem(className, 'description')}>
        {t('search:filters', 'Filters')}
      </p>
    </button>
  );
};

export default SearchResultsFilterButton;
